<a href="mailto:{{email}}" data-cy="contact-email">{{ email }}</a>
